"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlTransformFeedback = void 0;
/**
 * @public
 */
class GlTransformFeedback {
    constructor() {
        this.transformFeedback = null;
    }
    initialize(transformRenderer) {
        if (this.transformFeedback == null) {
            this.transformFeedback = transformRenderer.context.createTransformFeedback();
        }
        transformRenderer.addTransform(this);
    }
    onContextLost() {
        this.transformFeedback = null;
    }
    bind(transformRenderer) {
        const context = transformRenderer.context;
        context.bindTransformFeedback(context.TRANSFORM_FEEDBACK, this.transformFeedback);
    }
    beginTransform(transformRenderer) {
        const context = transformRenderer.context;
        context.enable(context.RASTERIZER_DISCARD);
        context.beginTransformFeedback(context.POINTS);
    }
    endTransform(transformRenderer) {
        const context = transformRenderer.context;
        context.endTransformFeedback();
        context.disable(context.RASTERIZER_DISCARD);
    }
}
exports.GlTransformFeedback = GlTransformFeedback;
//# sourceMappingURL=gl-transform-feedback.js.map